import { defineMessages } from 'react-intl';

export default defineMessages({
  comment: {
    id: 'sentinel.components.rejectTransferForm.comment',
    defaultMessage: 'Comment (optional)',
  },
  rejectReason: {
    id: 'sentinel.components.rejectTransferForm.rejectReason',
    defaultMessage: 'Reject Reason',
  },
  rejectTransfer: {
    id: 'sentinel.components.rejectTransferForm.rejectTransfer',
    defaultMessage: 'Reject Transfer',
  },
  NSF: {
    id: 'sentinel.components.rejectTransferForm.NSF',
    defaultMessage: 'Not Sufficient Funds',
  },
  RECENT_DEPOSIT_HOLD: {
    id: 'sentinel.components.rejectTransferForm.recentDepositHold',
    defaultMessage: 'Recent Deposit Hold',
  },
  COMPLIANCE: {
    id: 'sentinel.components.rejectTransferForm.Compliance',
    defaultMessage: 'Compliance',
  },
  AML: {
    id: 'sentinel.components.rejectTransferForm.AML',
    defaultMessage: 'AML',
  },
  PER_CORRESPONDENT_REQUEST: {
    id: 'sentinel.components.rejectTransferForm.perCorrespondentRequest',
    defaultMessage: 'Per Correspondent Request',
  },
  OUTSTANDING_ACAT: {
    id: 'sentinel.components.rejectTransferForm.outstandingACAT',
    defaultMessage: 'Outstanding ACAT',
  },
  INCORRECT_DISTRIBUTION_TYPE: {
    id: 'sentinel.components.rejectTransferForm.incorrectDistributionType',
    defaultMessage: 'Incorrect Distribution Type',
  },
  NAME_MISMATCH: {
    id: 'sentinel.components.rejectTransferForm.nameMisMatch',
    defaultMessage: 'Name Mismatch',
  },
  NO_INVALID_ACCOUNT: {
    id: 'sentinel.components.rejectTransferForm.noInvalidAccount',
    defaultMessage: 'No / Invalid Account',
  },
  NON_RESIDENCE_COUNTRY: {
    id: 'sentinel.components.rejectTransferForm.nonResidenceCountry',
    defaultMessage: 'Non-Residence Country',
  },
  THIRD_PARTY: {
    id: 'sentinel.components.rejectTransferForm.thirdParty',
    defaultMessage: 'Third Party',
  },
  THIRD_PARTY_INTERNATIONAL: {
    id: 'sentinel.components.rejectTransferForm.thirdPartyInternational',
    defaultMessage: 'Third Party International',
  },
  OTHER: {
    id: 'sentinel.components.rejectTransferForm.other',
    defaultMessage: 'Other',
  },
});



// WEBPACK FOOTER //
// ./src/components/RejectTransferForm/messages.js